import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../../i18n'
import { TextLink } from './types'

export const LIST_ITEMS_1 = [
  i18n.t(
    i18nKeys.safetyCourse_bike_step3__au__sub_heading1__list_item1__eBikes
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step3__au__sub_heading1__list_item2__eBikes
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step3__au__sub_heading1__list_item3__eBikes
  ),
]

export const LIST_ITEMS_2 = [
  i18n.t(
    i18nKeys.safetyCourse_bike_step3__au__sub_heading2__list_item1__eBikes
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step3__au__sub_heading2__list_item2__eBikes
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step3__au__sub_heading2__list_item3__eBikes
  ),
]

export const LIST_ITEMS_3: TextLink[] = [
  {
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step3__au__sub_heading5__list_item1__eBikes
    ),
    link:
      'https://roadsafety.transport.nsw.gov.au/stayingsafe/bicycle-riders/index.html',
  },
  {
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step3__au__sub_heading5__list_item2__eBikes
    ),
    link:
      'https://www.qld.gov.au/transport/safety/rules/wheeled-devices/bicycle#:~:text=Any%20motor%20must%20be%20electric,motor%20providing%20pedal%2Dassist%20only.',
  },
  {
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step3__au__sub_heading5__list_item3__eBikes
    ),
    link: 'https://www.sa.gov.au/topics/driving-and-transport/cycling',
  },
  {
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step3__au__sub_heading5__list_item4__eBikes
    ),
    link:
      'https://www.hobartlegal.org.au/handbook/community-and-environment/road-rules-for-cyclists-and-skaters/bicycle-and-cyclist-specific-laws/',
  },
  {
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step3__au__sub_heading5__list_item5__eBikes
    ),
    link:
      'https://www.vicroads.vic.gov.au/safety-and-road-rules/cyclist-safety',
  },
  {
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step3__au__sub_heading5__list_item6__eBikes
    ),
    link:
      'https://www.transport.wa.gov.au/activetransport/bicycle-rules-standards-and-safety.asp',
  },
  {
    text: i18n.t(
      i18nKeys.safetyCourse_bike_step3__au__sub_heading5__list_item7__eBikes
    ),
    link: 'https://www.police.act.gov.au/road-safety/share-road/cyclists',
  },
]
